import React from 'react';
/**
 * `Tabs` is a lightweight wrapper/container used to group tab-related UI.
 *
 * Styling is applied via `Tabs.scss`; the component itself only renders its
 * children.
 */
import './Tabs.scss';

export type TabsProps = {
  children?: React.ReactNode;
};

const Tabs = ({ children }: TabsProps): JSX.Element => {
  return <div>{children}</div>;
};

export default Tabs;
